






















































































import { Component, Vue,Prop ,Watch} from "vue-property-decorator";
import VueTimepicker from "vue2-timepicker";
import TimeZoneVue from "./TimeZoneJson.vue";


// import Login from "../components/Login.vue";
import gCal from "../../lib/google_calendar";
import AuthService from "../../lib/auth.service";
import GraphService from "../../lib/graph.service";
import { mapState } from "vuex";
import { store, CDR, StoreState, Timezone } from "../../store";
import moment from "moment";

//G:\HelloSpoke_2.0\HelloSpoke_2.0 (54.191.105.176) V1.4\dashboard_morit_2.0\src\components\Custom_select.vue
  import Custom_select from "../Custom_select.vue"
 import util from "../../lib/util";
import { ThematicBreak } from "docx";




@Component({
  components: {
    // Login,
   VueTimepicker,
    TimeZoneVue,
    Custom_select
  },
  computed: {
    ...mapState({
      show_quick_call_modal: (state: StoreState) => state.dashboard.show_quick_call_modal,
      conferencedata: (state: StoreState) => state.dashboard.ConferenceData,
      show_conference_modal: (state: StoreState) =>state.dashboard.show_conference_modal,
      conferenceuserlist: (state: StoreState) =>state.dashboard.ConferenceUserList,
      conferenceattendeesectionlist: (state: StoreState) =>state.dashboard.AttendeeSectionList,
      ConferecneParticipantList: (state: StoreState) => state.dashboard.ConferecneParticipantList,
      Confrence_On: (state: StoreState) => state.dashboard.Confrence_On,
      conferenceMainData:  (state: StoreState) => state.dashboard.ConferenceData
    })
  },
  mounted(){
     this.$data.minDate=new Date(); 
     this.$data.hourArr = util.timeArr();
  }
})
export default class Schedule extends Vue {
  data() {
    return {
      hourArr: [],
      closeImg: "img/icons/Extension_icon.png",
      authService: new AuthService(),
      graphService: new GraphService(),
      pickCalendar: "",
      selectedZone: "",
      eventTopic: "",
      eventHrs: "",
      eventMin: "",
      eventTime: "",
      minDate : '',
      eventDate: null,
      styleobj: {
        "background-color": ""
      },
      conference_call_in_number: "",
      Conference_ownername: "",
      validat_duration: false,
      submitted: false,
      timezonefrom: "",
      durationstatus: "required",
      Schedule_form: {
        eventTopic: "",
        eventDate: "",
        eventTime: "",
        eventTime_copy: "00:00",
        eventHrs: "",
        eventMin: "",
        selectedZone: "",
        pickCalendar: ""
      },
      time_validate:false,
      time: {
        _hr: "",
        _mm: "",
        _A: ""
      },
      
      Time_hr:[
              { time: "0", Id: 0 },
              { time: "1", Id: 1 },
              { time: "2", Id: 0 },
              { time: "3", Id: 1 },
              { time: "4", Id: 0 },
              { time: "5", Id: 1 },
              { time: "6", Id: 0 },
              { time: "7", Id: 1 },
              ],
              AMPM:'', 
              showDay: {
                  type: Boolean,
                  default: true,
                },
                showMonth: {
                  type: Boolean,
                  default: true,
                },
                showYear: {
                  type: Boolean,
                  default: true,
                },
               
		
    };

  }


  get _gettime(){
    var time=this.$data.Schedule_form.eventTime==""?true:false;
    console.log(this.$data.Schedule_form.eventTime)
    return time;
  }


      getVal(data)
          {
            if(data.click)
              return false;
            var dataindex= parseInt(data.index);
            let incoming = data.incoming;
            let type = incoming.type;
            switch(type)
            {
              case "time":
                this.$data.Schedule_form.eventTime=data.value;
                this.$data.time_validate=true;
          break;
          }}


      @Watch('conferenceMainData')
        SetConferencedata() {
         
          // this.$data.Conference_ownername = r.data.data.name;
          this.$data.Conference_ownername = (this as any).conferencedata.name;
        }
        //@Prop({ required: true }) value: [Number, String];
    
       onChg(evt) {
          this.$data.time._hr= ("0" +  this.$data.time._hr).slice(-2);
          
        }  

        onChg_mm(evt) {
        this.$data.time._mm= ("0" +  this.$data.time._mm).slice(-2);
        }  

       keydownt_HR(evt,val){
       //  alert(2)
        if(this.$data.time._hr =='01'&& !(evt.keyCode==38) && !(evt.keyCode==40)  && !(evt.keyCode==37) && !(evt.keyCode==39) && evt.key<=2){
          this.$data.time._hr =("1" +  evt.key).slice(-2);
        }
        else if(this.$data.time._hr =='00'){
            this.$data.time._hr='12';
            //document.getElementById("min").focus();  
        }
         else{
           if(!(evt.keyCode==40 || evt.keyCode==38 ) && !((evt.keyCode==39) || (evt.keyCode==37) ))
           {
               this.$data.time._hr = '';
          }
         }
         if(evt.keyCode==8){ this.$data.time._hr=''; } 
         if(evt.keyCode==38 ){ //top
         if(this.$data.time._hr==12){this.$data.time._hr=0}
         if(this.$data.time._hr>=12)
         {
           this.$data.time._hr=this.$data.time._hr-1;
         }
         else
         {   
          // if(this.$data.time._hr=='01'){this.$data.time._hr=0}
           if(this.$data.time._hr==""){this.$data.time._hr=0}
           this.$data.time._hr=parseInt(this.$data.time._hr)  +1;
           this.$data.time._hr= ("0" +  this.$data.time._hr).slice(-2);
         }
        }  
        if(evt.keyCode==40 ){ //Down
          if(this.$data.time._hr=='01'){this.$data.time._hr=13}
           if(this.$data.time._hr==""){this.$data.time._hr=13}
          this.$data.time._hr=parseInt(this.$data.time._hr) -1;
          this.$data.time._hr= ("0" +  this.$data.time._hr).slice(-2);
        }

         if(evt.keyCode==39 ){ //right
            document.getElementById("min").focus();
           }
            if(evt.keyCode==37 ){ //right
            document.getElementById("ampm").focus();
           }
       }

        keydownt_MM(evt){  
          if(this.$data.time._mm =='01'&& !(evt.keyCode==38) && !(evt.keyCode==40)  && !(evt.keyCode==37) && !(evt.keyCode==39)){
           this.$data.time._mm =("1" +  evt.key).slice(-2);
         }
         else if(this.$data.time._mm =='02' && !(evt.keyCode==38) && !(evt.keyCode==40) && !(evt.keyCode==37) && !(evt.keyCode==39) ){
          this.$data.time._mm =("2" +  evt.key).slice(-2);
         }
         else if(this.$data.time._mm =='03' && !(evt.keyCode==38) && !(evt.keyCode==40) && !(evt.keyCode==37) && !(evt.keyCode==39)){
          this.$data.time._mm =("3" +  evt.key).slice(-2);
         }
         else if(this.$data.time._mm =='04'&& !(evt.keyCode==38) && !(evt.keyCode==40) && !(evt.keyCode==37) && !(evt.keyCode==39)){
          this.$data.time._mm =("4" +  evt.key).slice(-2);
         }
         else if(this.$data.time._mm =='05'&& !(evt.keyCode==38) && !(evt.keyCode==40) && !(evt.keyCode==37) && !(evt.keyCode==39)){
          this.$data.time._mm =("5" +  evt.key).slice(-2);
         }
        //  else if(this.$data.time._mm =='00'){
        //    alert(this.$data.time._mm)
        //  }
         else{
          //  if(!(evt.keyCode==40 || evt.keyCode==38  ) && !((evt.keyCode==39) || (evt.keyCode==37) ) )
          //    this.$data.time._mm = '';
            if(!(evt.keyCode==40 || evt.keyCode==38 ) && !((evt.keyCode==39) || (evt.keyCode==37) )){
            
               this.$data.time._mm = '';}
         } 
           if(evt.keyCode==8){ this.$data.time._mm=''; }
      
         if(evt.keyCode==38 ){ //top
         if(this.$data.time._mm==59){this.$data.time._mm=-1}   
         if(this.$data.time._mm>=59)  
         {
           this.$data.time._mm=this.$data.time._mm-1;  
         }
         else
         {
           if(this.$data.time._mm==""){this.$data.time._mm=0}
           this.$data.time._mm=parseInt(this.$data.time._mm)  +1;
           this.$data.time._mm= ("0" +  this.$data.time._mm).slice(-2);
         }
        }  
        if(evt.keyCode==40 ){ //Down
          if(this.$data.time._mm=='00'){this.$data.time._mm=60}    
           if(this.$data.time._mm==""){this.$data.time._mm=60}
          this.$data.time._mm=parseInt(this.$data.time._mm) -1;
          this.$data.time._mm= ("0" +  this.$data.time._mm).slice(-2);
        }
         if(evt.keyCode==39 ){ //right
            document.getElementById("ampm").focus();
           }
            if(evt.keyCode==37 ){ //right
            document.getElementById("hr").focus();
           }
       }


      keydown_ampm(evt){
        if(evt.keyCode==38 ){ //top
           this.$data.time._A=this.$data.time._A=="AM"?'PM':'AM';
        }
        if(evt.keyCode==40 ){ //Down
          this.$data.time._A=this.$data.time._A=="AM"?'PM':'AM';
        }
        if(evt.keyCode==37 ){ //right
            document.getElementById("min").focus();
           }
        if(!(evt.keyCode==38|| evt.keyCode==40))
        {
          evt.preventDefault();
        }
      }

     focusinput(evt){
       var actv_clss=document.activeElement;
       if(actv_clss["_prevClass"]=="FormDate__input FormDate__input--hr"){
          if(evt.keyCode==39 ){ //right
            document.getElementById("min").focus();
           }
       }
       if(actv_clss["_prevClass"]=="FormDate__input FormDate__input--mm")
       {
          if(evt.keyCode==37 ){ //left
                document.getElementById("hr").focus();
                
          }
           if(evt.keyCode==39 ){ //right
            document.getElementById("ampm").focus();
           }
       }
       
      }

  async created() {
    this.$data.minDate=new Date(); 
    this.$store.dispatch("getCallflows").then(r => {
      this.$data.conference_call_in_number = this.formatPhoneNumber(
        r.data.data[0].numbers[0]
      );
    });
 
  }
     isNumber(event, message ) {
            if (!/\d/.test(event.key) &&   (event.key !== "." || /\./.test(message)) )  
                return event.preventDefault();  

                //Hr/Min validation should'n accept more tha 24 and 60 
                var value=event.target.value+''+ event.key;
                 var number = parseFloat(value);
                      if(message=='hr' && number > 24){  
                       return event.preventDefault();  
                       }
                        if(message=='min' && number > 60){  
                       return event.preventDefault();  
                       }
    }
 
  formatPhoneNumber(phoneNumber: any) {
    if (typeof phoneNumber === "number") {
      phoneNumber = phoneNumber.toString();
    }
    const re = /(?:\+1)?(\d{3})(\d{3})(\d{4})/;
    const matches = phoneNumber.match(re);
    if (matches === null) {
      console.log("The phone number " + phoneNumber + " could not be parsed");
      return "Invalid number";
    }
    return `+1 ${matches[1]} ${matches[2]} ${matches[3]}`;
  }

  closingModal() {
    this.resetDataModal();
    this.$emit('clicked', 'Bridge');
  }
  
  resetDataModal() {
    this.$data.Schedule_form = {
      eventTopic: "",
      eventDate: "",
      eventTime: "00:00",
      eventHrs: "",
      eventMin: "",
      selectedZone: "",
      pickCalendar: ""
    };    
    this.$data.time = {
      hh: "01",
      mm: "00",
      A: "AM"
    }
  } 
  onlyNumber ($event) {
    //console.log($event.keyCode); //keyCodes value
    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
    }
  }

  durationchange() {
    this.$data.validat_duration = this.$data.Schedule_form.eventHrs == "0" &&this.$data.Schedule_form.eventMin == "0" ? true  : false;
    this.$data.Schedule_form.eventMin=this.$data.Schedule_form.eventMin==""?0:this.$data.Schedule_form.eventMin;
   // this.$data.Schedule_form.eventMin=0;
    // this.$data.durationstatus = "";
    // if (
    //   this.$data.Schedule_form.eventHrs != "" &&
    //   this.$data.Schedule_form.eventMin == ""
    // ) {
    //   this.$data.Schedule_form = {
    //     eventTopic: this.$data.Schedule_form.eventTopic,
    //     eventDate: this.$data.Schedule_form.eventDate,
    //     eventTime: this.$data.Schedule_form.eventTime,
    //     eventHrs: this.$data.Schedule_form.eventHrs,
    //     eventMin: this.$data.Schedule_form.eventMin,//0,
    //     selectedZone: this.$data.timezonefrom,
    //     pickCalendar: this.$data.Schedule_form.pickCalendar
    //   };
    // }
    // if (
    //   this.$data.Schedule_form.eventHrs == "" &&
    //   this.$data.Schedule_form.eventMin != ""
    // ) {
    //   this.$data.Schedule_form = {
    //     eventTopic: this.$data.Schedule_form.eventTopic,
    //     eventDate: this.$data.Schedule_form.eventDate,
    //     eventTime: this.$data.Schedule_form.eventTime,
    //     eventHrs: this.$data.Schedule_form.eventHrs,//0,
    //     eventMin: this.$data.Schedule_form.eventMin,
    //     selectedZone: this.$data.timezonefrom,
    //     pickCalendar: this.$data.Schedule_form.pickCalendar
    //   };
    // } else {
    //   this.$data.Schedule_form = {
    //     eventTopic: this.$data.Schedule_form.eventTopic,
    //     eventDate: this.$data.Schedule_form.eventDate,
    //     eventTime: this.$data.Schedule_form.eventTime,
    //     eventHrs: this.$data.Schedule_form.eventHrs,
    //     eventMin: this.$data.Schedule_form.eventMin,
    //     selectedZone: this.$data.timezonefrom,
    //     pickCalendar: this.$data.Schedule_form.pickCalendar
    //   };
    // }
  }

  timeZoneChange(newTimezone) {
    this.$data.timezonefrom = newTimezone;
  }
 SUBMIT_SCHEDULE(e) {
    this.$data.submitted = true;
    var form = this.$data.Schedule_form;
    this.$data.validat_duration = form.eventHrs == "0" && form.eventMin == "0" ? true : false;
    form.selectedZone = this.$data.timezonefrom;
    this.$data.Schedule_form.eventTime
    var e_time=JSON.parse(JSON.stringify(this.$data.Schedule_form.eventTime));
    console.log(e_time)
    form.eventTime_copy=e_time.slice(0, -3);
    this.$validator.validate().then(valid => {
      this.$data.submitted =valid && this.$data.time_validate ? false : true;
      if (!this.$data.submitted && !this.$data.validat_duration ) {
        const convert = num => (num < 10 ? "0" + num : num);
        const convertDt = dt =>`${dt.getFullYear()}-${convert(dt.getMonth() + 1)}-${convert(dt.getDate())}`;
        const dt = convertDt(form.eventDate);
        form.selectedZone = this.$data.timezonefrom;
        const tZone = form.selectedZone.split("$")[0];
        const hrs = +form.eventHrs * 60 * 60 * 1000;
        const mins = +form.eventMin * 60 * 1000;
        //  const getms = new Date(`${dt}T${form.eventTime}:00`).getTime();

        //TimeZone format
        var dtimewew = form.eventTime_copy + ":" + "00";
       
        const convertDt2 = dt2 =>`${convert(dt2.getMonth() + 1)}/${convert(dt2.getDate())}/${dt2.getFullYear()}`;
        const dt2 = convertDt2(form.eventDate);
        var cdat = dt2 + "  " + dtimewew;
        const getms = new Date(cdat).getTime();
        const totalMs = getms + hrs + mins;
        const year = new Date(totalMs).getFullYear();
        const month = convert(new Date(totalMs).getMonth() + 1);
        const date = convert(new Date(totalMs).getDate());
        const getHrs = convert(new Date(totalMs).getHours());
        const getMin = convert(new Date(totalMs).getMinutes());
        const getendTime = `${year}-${month}-${date} ${getHrs}:${getMin}:00`;
        const getdtTime = `${dt} ${form.eventTime_copy}:00`;
       
        const schedule_getTime=moment(String(getdtTime)).format('MMM DD, YYYY ') +' '+ e_time;

        const localtimezone = moment.tz.guess();
        const offset = form.selectedZone.split("$")[0];
        const selectedZone = form.selectedZone.split("$")[1];
        const momentst = moment.tz(getdtTime, selectedZone).clone().tz(localtimezone).format();

        const momentend = moment.tz(getendTime, selectedZone).clone().tz(localtimezone).format();
        const stISO = `${dt}T${form.eventTime_copy}:00${tZone}`;
        const endMs =+new Date(stISO) +(+form.eventHrs * 60 * 60 + +form.eventMin * 60) * 1000;
        const endDt = `${new Date(endMs).toISOString().split(".")[0]}${tZone}`;
        const memberpin =(this as any).conferencedata.member.pins.length > 0? (this as any).conferencedata.member.pins[0]: "";
        const conference_number = (this as any).conferencedata.conference_numbers[0];
        const conference_owner_name = this.$data.Conference_ownername.split()[0];
       
        var topic =conference_owner_name + "'s" + " " + form.eventTopic +" conference meeting";
        // var description = `\t${conference_owner_name} is inviting you to a scheduled Conference Call.\n
        //       Topic  : ${topic}\n
        //       Time   : ${moment(String(getdtTime)).format(
        //         "MMM DD, YYYY hh:mm a"
        //       )} ${form.selectedZone.split("$")[2]}\n
        //       Call-in Number : ${this.$data.conference_call_in_number}\n
        //       Conference Number : ${conference_number}\n
        //       ${memberpin.length ? "Participation PIN: " + memberpin : ""}`;

        //var description = `${conference_owner_name} is inviting you to a scheduled Conference Call \n\nTopic  : ${topic}\n\nTime   : ${moment(String(getdtTime)).format('MMM DD, YYYY hh:mm a')} ${form.selectedZone.split('$')[2]}\n\nCall-in Number : ${this.$data.conference_call_in_number}\n\nConference Number : ${conference_number}\n\n ${ memberpin.length? 'Participation PIN: ' + memberpin: ''}`;var description = `${conference_owner_name} is inviting you to a scheduled Conference Call \n\nTopic  : ${topic}\n\nTime   : ${moment(String(getdtTime)).format('MMM DD, YYYY hh:mm a')} ${form.selectedZone.split('$')[2]}\n\nCall-in Number : ${this.$data.conference_call_in_number}\n\nConference Number : ${conference_number}\n\n ${ memberpin.length? 'Participation PIN: ' + memberpin: ''}`;var description = `${conference_owner_name} is inviting you to a scheduled Conference Call \n\nTopic  : ${topic}\n\nTime   : ${moment(String(getdtTime)).format('MMM DD, YYYY hh:mm a')} ${form.selectedZone.split('$')[2]}\n\nCall-in Number : ${this.$data.conference_call_in_number}\n\nConference Number : ${conference_number}\n\n ${ memberpin.length? 'Participation PIN: ' + memberpin: ''}`;
        var description = `${conference_owner_name} is inviting you to a scheduled Conference Call \n\nTopic  : ${topic}\n\nTime   : ${schedule_getTime} ${form.selectedZone.split('$')[2]}\n\nCall-in Number : ${this.$data.conference_call_in_number}\n\nConference Number : ${conference_number}\n\n ${ memberpin.length? 'Participation PIN: ' + memberpin: ''}`;var description = `${conference_owner_name} is inviting you to a scheduled Conference Call \n\nTopic  : ${topic}\n\nTime   : ${schedule_getTime} ${form.selectedZone.split('$')[2]}\n\nCall-in Number : ${this.$data.conference_call_in_number}\n\nConference Number : ${conference_number}\n\n ${ memberpin.length? 'Participation PIN: ' + memberpin: ''}`;var description = `${conference_owner_name} is inviting you to a scheduled Conference Call \n\nTopic  : ${topic}\n\nTime   : ${schedule_getTime} ${form.selectedZone.split('$')[2]}\n\nCall-in Number : ${this.$data.conference_call_in_number}\n\nConference Number : ${conference_number}\n\n ${ memberpin.length? 'Participation PIN: ' + memberpin: ''}`;

       // get formated date time for google calendar event description
       const fd: any = momentst.split("T")[0].split("-");
        const ft = momentst.split("T")[1].split("-");
        const fed: any = momentend.split("T")[0].split("-");
        const fet = momentend.split("T")[1].split("-");
        const fullDate = `${moment.months(Number(fd[1]) - 1)} ${fd[2]}, ${fd[0] }`;
        const H = +ft[0].substr(0, 2);
        const h = H % 12 || 12;
        const ampm = H < 12 || H === 24 ? "AM" : "PM";
        const fullTime = h + ft[0].substr(2, 3) + ampm;
        // for ical
        const istdt = `${fd[0]}${fd[1]}${fd[2]}T`;
        const isttimesplit = ft[0].split(":");
        const istt = `${isttimesplit[0]}${isttimesplit[1]}${isttimesplit[2]}`;
        const ifinalst = `${istdt}${istt}Z`;

        const iseddt = `${fed[0]}${fed[1]}${fed[2]}T`;
        const iedtimesplit = fet[0].split(":");
        const iedt = `${iedtimesplit[0]}${iedtimesplit[1]}${iedtimesplit[2]}`;
        const ifinaled = `${iseddt}${iedt}Z`;

        var _eventData = {
          summary: form.eventTopic,
          end: { dateTime: momentend },
          start: { dateTime: momentst },
          location: "Conference Call",
          description: description
        };

        window["eventData"] = _eventData;
        if (form.pickCalendar.toLowerCase() === "google") {
          window["gapi"].load("client:auth2", gCal.initialize.bind(gCal));
          // this.resetDataModal();
        } else if (form.pickCalendar.toLowerCase() === "outlook") {
          // outlook
          this.$data.authService.login().then(
            user => {
              if (user) {
                this.$data.authService.getToken().then(
                  token => {
                    const data = {
                      subject: _eventData.summary,
                      start: {
                        dateTime: _eventData.start.dateTime,
                        timeZone: selectedZone
                      },
                      end: {
                        dateTime: _eventData.end.dateTime,
                        timeZone: selectedZone
                      },
                      location: {
                        displayName: _eventData.location
                      },
                      body: {
                        contentType: "text",
                        content: `${description}\r\n\r\n`
                      }
                    };
                    this.$data.graphService.getUserInfo(token, data).then(
                      data => {
                        window.open(data.webLink);
                      },
                      error => {
                        console.error(error);
                      }
                    );
                  },
                  error => {
                    console.error(error);
                  }
                );
              } else {
                console.log("not user");
              }
            },
            () => {
              console.log("error in user");
            }
          );          
          // this.resetDataModal();
        } else if (form.pickCalendar.toLowerCase() === "ical") {
          const offset1 = String(Number(offset.split(":").join("")));
          const offset2 = `${String(offset1)[0]}0${String(offset1).slice(1)}`;
          const convertFunc = (dt, flag) => {
            if (flag) {
              const dt1 = dt
                .split("T")[0]
                .split("-")
                .join("");
              const dt2 = dt
                .split("T")[1]
                .split("+")[0]
                .split(":")
                .join("");
              return `${dt1}T${dt2}Z`;
            } else {
              const dt1 = dt
                .split(" ")[0]
                .split("-")
                .join("");
              const dt2 = dt
                .split(" ")[1]
                .split(":")
                .join("");
              return `${dt1}T${dt2}`;
            }
          };
          const now1 = moment()
            .tz(moment.tz.guess())
            .format();
          const now2 = now1
            .split("T")[0]
            .split("-")
            .join("");
          const now3 = now1
            .split("T")[1]
            .split("+")[0]
            .split(":")
            .join("");
          const now4 = `${now2}T${now3}Z`;

          const prepareEventSample = data => {
            description = description.replace(/\n/g, "\\n");
            var tData = `BEGIN:VCALENDAR`;
            tData += `\nVERSION:2.0`;
            tData += `\nCALSCALE:GREGORIAN`;
            tData += `\nMETHOD:PUBLISH`;
            tData += `\nCLASS:PUBLIC`;
            tData += `\nBEGIN:VTIMEZONE`;
            tData += `\nTZID:${selectedZone}`;
            tData += `\nBEGIN:STANDARD`;
            tData += `\nTZOFFSETFROM:${offset1}`;
            tData += `\nTZOFFSETTO:${offset1}`;
            tData += `\nDTSTART:19701101T020000`;
            tData += `\nRRULE:FREQ=YEARLY;BYMONTH=11;BYDAY=1SU`;
            tData += `\nEND:STANDARD`;
            tData += `\nEND:VTIMEZONE`;
            tData += `\nBEGIN:VEVENT`;
            tData += `\nDTSTAMP:${convertFunc(now1, true)}`;
            tData += `\nDTSTART;TZID=${selectedZone}:${convertFunc(
              getdtTime,
              false
            )}`;
            tData += `\nDTEND;TZID=${selectedZone}:${convertFunc(
              getendTime,
              false
            )}`;
            tData += `\nSUMMARY:${topic}`;
            tData += `\nUID:${Math.floor(
              Math.random() * 10000000
            )}-Custom@test`;
            tData += `\nTZID:${selectedZone}`;
            tData += `\nDESCRIPTION:${description}`;
            tData += `\nLOCATION:${this.$data.conference_call_in_number}`;
            tData += `\nBEGIN:VALARM`;
            tData += `\nTRIGGER:-PT10M`;
            tData += `\nACTION:DISPLAY`;
            tData += `\nDESCRIPTION:Reminder`;
            tData += `\nEND:VALARM`;
            tData += `\nEND:VEVENT`;
            tData += `\nEND:VCALENDAR`;
            return tData;
          };

          var contents = prepareEventSample(_eventData);

          var dlurl = "data:text/calendar;base64," + btoa(contents);
          var name = `${form.eventTopic}.ics`;

          if (!window["ActiveXObject"]) {
            var save = document.createElement("a");
            save.href = dlurl;
            save.target = "_blank";
            save.download = name || "unknown";

            var evt = new MouseEvent("click", {
              view: window,
              bubbles: true,
              cancelable: false
            });
            save.dispatchEvent(evt);

            (window.URL || window["webkitURL"]).revokeObjectURL(save.href);
          }          
          // this.resetDataModal();
        }
      }
    });
  }
 
}
